module.exports = __webpack_public_path__ + "static/media/Шаг 1.0da6c7e3.png";